import { computed, makeAutoObservable } from "mobx";
import { FormSection, IFormSection } from "./FormSection";
import { FormInputItem, isInputItem, OptionsPageMapping } from "./FormInputItem";
import { NavigationRule } from "./interfaces/NavigationRule";

export interface IFormPage {
    id: string;
    defaultNavigation: NavigationRule;
    // title: string;
    sections: IFormSection[];
}

export class FormPage implements IFormPage {
    id: string;
    defaultNavigation: NavigationRule;
    // title: string;
    sections: FormSection[];

    constructor(page: IFormPage) {
        makeAutoObservable(this);

        this.id = page.id;
        this.defaultNavigation = page.defaultNavigation;
        // this.title = page.title;
        this.sections = page.sections.map(section => {
            return new FormSection(section);
        });
    }

    @computed get advanceTo() {
        const lastItemWithPageMapping = this.sections.flatMap(section => section.items).findLast(item => isInputItem(item) && item.optionsPageMapping && typeof item.value === 'string' && item.optionsPageMapping[item.value]) as undefined | { optionsPageMapping: OptionsPageMapping, value: string };
        if (lastItemWithPageMapping) {
            return lastItemWithPageMapping.optionsPageMapping[lastItemWithPageMapping.value];
        }
        return this.defaultNavigation;
    }

    setAllFieldsDirty() {
        this.inputFields.forEach(inputField => inputField.setAllFieldsDirty());
    }

    @computed get validated() {
        return this.validationErrors.length === 0;
    }

    @computed get validationErrors() {
        return this.inputFields.flatMap(inputField => inputField.validationErrors);
    }

    @computed private get inputFields() {
        return this.sections.flatMap(section => section.items).filter(item => isInputItem(item)) as FormInputItem[];
    }
}